export default __webpack_public_path__ + "static/media/level_1.7c18cf3b.jpg";